import { GET_MENU_CATEGORIES_REQUEST, SET_MENU_CATEGORIES } from './category.action';

const initialState = {
  categories: [],
  loading: false,
  error: undefined
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined
      };
    case SET_MENU_CATEGORIES:
      return {
        ...state,
        loading: false,
        categories: action.data || [],
        error: action.error || undefined
      };
    default:
      return state;
  }
};

export default categoryReducer;
